import { SizingMultiplier, Typography } from '@ocx/ui';

export type ReceiptPromotionChipProps = {
  label: string;
  fullWidth?: boolean;
};
export const ReceiptPromotionChip = (props: ReceiptPromotionChipProps) => {
  const { label, fullWidth = false } = props;

  return (
    <Typography
      sx={(theme) => ({
        borderRadius: theme.spacing(SizingMultiplier.sm),
        bgcolor: theme.palette.Receipts.offerLinkBackground,
        display: fullWidth ? 'block' : 'inline-block',
        color: theme.palette.Receipts.offerLinkColor,
        padding: theme.spacing(SizingMultiplier.xs),
        whiteSpace: fullWidth ? 'normal' : 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: fullWidth ? '100%' : '70%',
        boxSizing: 'border-box',
      })}
      variant="subtitle2">
      {label}
    </Typography>
  );
};
